<template>
  <div class="app-container shopType">
    <div class="typeHeader">
      <el-button size="small" type="primary" @click="onAdd">新增</el-button>
      <div>
        <el-input
          v-model="listQuery.name"
          placeholder="课程名称"
          :clearable="true"
          style="width: 200px;margin: 0px 10px;margin-left: 5px;"
        ></el-input>

        <el-select v-model="listQuery.teacher_id" placeholder="讲师" 
          style="width: 150px;margin: 0px 10px;margin-left: 5px;"
            :clearable="true"

        >
          <el-option
            v-for="item in TeacherList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            
            >
          </el-option>
        </el-select>

        <el-select v-model="listQuery.type_id" placeholder="课程系列"
          style="width: 200px;margin: 0px 10px;margin-left: 5px;"
            :clearable="true"

        >
          <el-option
            v-for="item in TypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            >
          </el-option>
        </el-select>


        <el-select
            v-model="listQuery.type"
            placeholder="类型"
            :clearable="true"
            style="width: 120px;margin: 0px 10px;margin-left: 5px;"
        >
            <el-option label="会员免费" value="1"></el-option>
            <el-option label="限时免费" value="2"></el-option>
        </el-select>

        <el-select
        v-model="listQuery.state"
        placeholder="上下架"
        :clearable="true"
        style="width: 120px;margin: 0px 10px;margin-left: 5px;"
    >
        <el-option label="上架中" value="1"></el-option>
        <el-option label="下架" value="0"></el-option>
        </el-select>
        <el-button
        size="small"
        type="primary"
        @click="handleSearch"
        style="margin-left: 10px"
        >搜索</el-button
        >
        </div>
    </div>

    <el-dialog :title="title" v-if="showDialog" :visible.sync="showDialog">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        
        <el-form-item label="课程标题" prop="title">
          <el-input
            v-model="form.title"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="划线价格" prop="mark_price">
          <el-input
            v-model="form.mark_price"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入价格"
          ></el-input>
        </el-form-item>

        <el-form-item label="缩略图" prop="thumbnail">
          <upload-one
            v-model="form.thumbnail"
            width="100px"
            height="100px"
          >
          </upload-one>
        </el-form-item>
        
        <el-form-item label="封面" prop="cover">
          <upload-one
            v-model="form.cover"
            width="300px"
            height="300px"
          >
          </upload-one>
        </el-form-item>

        <el-form-item label="视频" prop="video">
          <upload-one
            v-model="form.video"
            width="200px"
            height="200px"
          >
          </upload-one>

        </el-form-item>
        
        <el-form-item label="视频预览">
          <video :src="form.video" controls width="400px" height="300px"></video>
        </el-form-item>

        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type">
            <el-option label="会员免费" :value="1" />
            <el-option label="限时免费" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="讲师" prop="teacher_id">{{TeacherList}}
        <el-select v-model="form.teacher_id" placeholder="请选择">
          <el-option
            v-for="item in TeacherList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            >
          </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程系列" prop="type_id">
        <el-select v-model="form.type_id" placeholder="请选择">
          <el-option
            v-for="item in TypeList2"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            >
          </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="富文本" prop="content">
          <tinymce ref="tinymce" style="width:100%;" :height="300" v-model="form.content" :value="form.content" />
        </el-form-item>
        
        <el-form-item label="权重" prop="sort">
          <el-input-number
            v-model="form.sort"
            :min="1"
          ></el-input-number>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleCancel">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmit"
            type="primary"
            :loading="btnLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-table
      :data="list"
      :loading="listLoading"
      border
      highlight-current-row
      style="margin-top: 15px"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>

      <el-table-column align="center" label="课程系列" width="120">
        <template slot-scope="scope">{{ scope.row.course_type.name }}</template>
      </el-table-column>

      <el-table-column align="center" label="课程标题" width="95">
        <template slot-scope="scope">{{ scope.row.title }}</template>
      </el-table-column>

      <el-table-column label="缩略图" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.thumbnail"  style="width: 100px; height: 100px" />
           <!-- <el-avatar  :src="scope.row.head_img"  ></el-avatar> -->
        </template>
      </el-table-column>

      <el-table-column label="封面" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.cover"  style="width: 100px; height: 100px" />
           <!-- <el-avatar  :src="scope.row.head_img"  ></el-avatar> -->
        </template>
      </el-table-column>

      <el-table-column label="讲师头像" min-width="90" align="center">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.head_img" class="user-avatar" /> -->
           <el-avatar  :src="scope.row.teacher.head_img"  :size="90"></el-avatar>
        </template>
      </el-table-column>  

      <el-table-column align="center" label="讲师名称" width="100">
        <template slot-scope="scope">{{ scope.row.teacher.name }}</template>
      </el-table-column>

      <el-table-column align="center" label="观看人数" min-width="110">
        <template slot-scope="scope">{{ scope.row.view_number}}</template>
      </el-table-column>

      <el-table-column align="center" label="收藏人数" min-width="110">
        <template slot-scope="scope">{{ scope.row.collect_number}}</template>
      </el-table-column>

      <el-table-column align="center" label="点赞人数" min-width="110">
        <template slot-scope="scope">{{ scope.row.like_number}}</template>
      </el-table-column>

      <el-table-column align="center" label="权重" min-width="110">
        <template slot-scope="scope">{{ scope.row.sort}}</template>
      </el-table-column>

      <el-table-column align="center" label="状态" min-width="110">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.state == 1">上架中</el-tag>
          <el-tag type="warning" v-else>已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="400">
        <template slot-scope="scope">
          <el-button size="small" @click="onEdit(scope.row)">修改</el-button>
          <el-button
            size="small"
            :type="scope.row.state == 1 ? 'warning' : 'success'"
            @click="handleUpShelf(scope.row)"
            >{{ scope.row.state == 1 ? "下架" : "上架" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";
import Tinymce from '@/components/Tinymce'

export default {
  components: {
    UploadOne,Tinymce,
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      listLoading: true,
      total: null,
      listQuery: {
        page: 1,
        limit: 10,
      },
      form: {
        id:'',
        cover:'',
        video:'',
        type:'',
        teacher_id:'',
        type_id:'',
        title:'',
        content:'',
        sort:'',
        mark_price:'',
      },
      jumpList:[
        {id:1,name:'普通'},
        {id:2,name:'限制'},
      ],
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        thumbnail: [{ required: true, message: "请上传缩略图", trigger: "blur" }],
        cover: [{ required: true, message: "请上传封面", trigger: "blur" }],
        video: [{ required: true, message: "请上传视频", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        teacher_id: [{ required: true, message: "请选择老师", trigger: "blur" }],
        type_id: [{ required: true, message: "请选择系列", trigger: "blur" }],
        mark_price: [{ required: true, message: "请输入划线价格", trigger: "blur" }],
      },
      showDialog: false,
      btnLoading: false,
      title: "", // dialog显示的标题
      list: [],
      TypeList: [],
      TypeList2: [],
      TeacherList: [],
      schools: [],
      videoUrl: ''
    };
  },
  mounted() {
    this.getList();
    this.getTeacherList();
    this.getTypeList();
    this.getTypeList2();
  },
  methods: {
    handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
    onAdd() {
      this.title = "新增类型";
      this.resetData();
      this.dynamicTags= [];
      this.showDialog = true;
    },

    getTeacherList() {
      this.listLoading = true;
      request({
        url: "/api/backend/CourseTeacherList",
        method: "get",
        params: {
          limit:9999999,
        },
      })
        .then((result) => {
          this.TeacherList = result.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((err) => {
          console.log(err);
        });
    },

    getTypeList() {
      this.listLoading = true;
      request({
        url: "/api/backend/CourseTypeList",
        method: "get",
        params: {
          limit:9999999,
        },
      })
        .then((result) => {
          this.TypeList = result.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((err) => {
          console.log(err);
        });
    },

    getTypeList2() {
      this.listLoading = true;
      request({
        url: "/api/backend/CourseTypeList",
        method: "get",
        params: {
          state:1,
          limit:9999999,
        },
      })
        .then((result) => {
          this.TypeList2 = result.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((err) => {
          console.log(err);
        });
    },

    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/CourseList",
        method: "get",
        params: this.listQuery,
      })
        .then((result) => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((err) => {
          console.log(err);
        });
    },
    resetData() {
      this.form = {
        id:'',
        cover:'',
        video:'',
        type:'',
        teacher_id:'',
        type_id:'',
        title:'',
        content:'',
        sort:'',
        mark_price:'',
      };
    },
    handleSearch() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getList();
    },
    handleCancel() {
      this.btnLoading = false;
      this.showDialog = false;
    },
    handleSubmit() {
      // if (!this.form.title) {
      //   this.$message({
      //     type: "error",
      //     message: "请填写标题!",
      //   });
      //   return;
      // } 

      // if (!this.form.cover) {
      //   this.$message({
      //     type: "error",
      //     message: "请上传封面!",
      //   });
      //   return;
      // } 

      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then((result) => {
              request({
                url: "/api/backend/CourseAdd",
                method: "post",
                data: this.form,
              })
                .then((result) => {
                  this.$notify.success("操作成功");
                  this.getList();
                })
                .catch((err) => {
                  this.$notify.error("操作失败");
                })
                .finally(() => {
                  this.btnLoading = false;
                  this.showDialog = false;
                });
            })
            .catch((err) => {
              this.$notify.info("已取消");
              this.btnLoading = false;
            });
        }
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleUpShelf(row) {
      let self = this;
      let state = !row.status ? "上架" : "下架";
      self
        .$confirm(`此操作将会${state}该商品类型，是否继续`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then((result) => {
          request({
            url: "/api/backend/CourseState",
            method: "post",
            data: {
              id: row.id,
            },
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
        });
    },

  
    onEdit(row) {
      this.title = "修改";
      this.form = Object.assign({}, row);
      this.dynamicTags = this.form.label;
      this.showDialog = true;
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.typeHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
=